const classes = {
  class: "Class",
  classes: "Classes",
  publication: "Publishing",
  level: "Level",
  create: "Create a new class",
  follow: "My classes",
  followed: "My classes",
  edit: "Edit class",
  save: "Save class",
  hasNoClassWarning: "You don’t have any classes yet.",
  hasNoClassWithStudentStart: "You have",
  hasNoClassWithStudentEnd:
    "class(es) where no students have accessed iizenglish yet. Classes will appear once at least one student has logged in.",
  deleteStudentQuestion: "Remove this student from the class?",
  deleteStudentDescription:
    "The student will no longer be part of this class. Once confirmed, the action will take effect immediately.",
  selectedClasses: "Selected classes",
  atLeastOneSelectedClass: "Please select at least one class.",
  searchSchoolHere: "Search for a school…",
  searchTeacherHere: "Search for a teacher…",
  searchSchoolHelp:
    "Please select a school from the dropdown list, or leave this field empty if you are not affiliated with any school.",
  removedTeacherClassHelp: "Save the class to apply the changes.",
  searchClassHere: "Search for a class…",
  languageHelp: "Used to set the language of emails sent to the student.",
  addTeacherModalTitle: "Join class",
  addTeacherModalContent:
    "You are about to join the class {className} as a teacher. Are you sure you want to continue?",
  newTeacher: "New teacher",
  theWholeClass: "Entire class",
  theWholeClasses: "The whole classes",
  myClasses: "My classes",
  atLeastOneLevel: "Please select at least one level.",
  deleteClassQuestionForTeacher: "Are you sure you want to delete this class?",
  deleteClassWarning:
    "This action cannot be undone. Assignments assigned only to this class will also be deleted.",
  className: "Class name",
  classCreation: "Create a class",
  classEdition: "Edit class",
  notEditable: "This class was imported from your ENT and cannot be edited.",
  addClass: "Add a class",
  classList: "Class list",
  deleteClassQuestion: "Delete this class ?",
  deleteClass: "Delete class",
  deleteClassDescription:
    "All associated assignments and grades will be permanently deleted.",
};

export default classes;
